import { TimeSegmentKey } from "./types";

/* #region time */

export const MS_IN_SECOND = 1000;
export const MS_IN_MINUTE = 60 * MS_IN_SECOND;
export const MS_IN_HOUR = 60 * MS_IN_MINUTE;

/** Segments are always rendered in this order, whichever subset is enabled. */
export const SEGMENT_ORDER: TimeSegmentKey[] = ["hours", "minutes", "seconds"];
export const DEFAULT_SEGMENTS: TimeSegmentKey[] = SEGMENT_ORDER;

export const DEFAULT_UNIT_LABELS: Record<TimeSegmentKey, string> = {
  hours: "HH",
  minutes: "MM",
  seconds: "SS",
};

/** A segment is two digits wide, so 99 is the hard ceiling for any of them. */
export const MAX_SEGMENT_VALUE = 99;
/** Characters a single segment occupies in the text, including its separator. */
export const SEGMENT_TEXT_LENGTH = 3;
/** Digits per segment. Every segment is exactly two digits wide. */
export const SEGMENT_DIGITS = 2;
export const DEFAULT_MAX_HOURS = 23;
export const DEFAULT_MAX_MINUTES = 59;
export const DEFAULT_MAX_SECONDS = 59;

/* #endregion */

/* #region popup geometry */

/**
 * Geometry lives here (and is handed to the CSS module as custom properties) so
 * that the height used to position the popup can never drift from the height
 * that is actually rendered.
 */
export const ITEM_HEIGHT_DESKTOP = 40;
export const ITEM_HEIGHT_TOUCH = 44;
export const COLUMN_WIDTH_DESKTOP = 72;
export const COLUMN_WIDTH_TOUCH = 64;
export const SEPARATOR_WIDTH = 10;
export const POPUP_PADDING = 8;
export const POPUP_BORDER = 1;
export const LABEL_HEIGHT = 20;
export const LABEL_GAP = 4;
export const ACTIONS_HEIGHT = 48;
/** Distance between the input and the popup. */
export const POPUP_GAP = 4;
/** Smallest allowed distance between the popup and the edge of the viewport. */
export const VIEWPORT_MARGIN = 8;
export const MIN_VISIBLE_ITEMS = 3;
export const DEFAULT_VISIBLE_ITEMS = 5;

/* #endregion */

/* #region scroll wheel timings */

/** How long to wait after the last scroll event before the snapped option is committed. */
export const SCROLL_SETTLE_DELAY = 140;

/* #endregion */
